import React, {Component} from 'react';
import {observer} from "mobx-react";
import AutosizeInput from 'react-input-autosize';

class String extends Component {
  render() {
    if(this.props.locked) {
      return this.props.item.value;
    }
    return (
      <div>
        <AutosizeInput
          inputRef={(ref) => {
            this.props.inputRef(ref);
          }}
          onKeyDown={(e) => {
            this.props.onKeyDown(e);
          }}
          type="text"
          inputClassName="small"
          placeholder={"Поиск!"}
          value={this.props.item.value}
          onChange={(e) => {
            const arg=e.target.value.matchAll(/([<>=!~]?[><=]?)(.+)/gi).next();
            if(arg.value) {
              if(arg.value[2]) {
                if(arg.value[1] === '~' ||arg.value[1] === '=' || arg.value[1] === '!=' || arg.value[1] === '>' || arg.value[1] === '<' || arg.value[1] === '>=' || arg.value[1] === '<=') {
                  this.props.item.compare=arg.value[1];
                  e.target.value=arg.value[2];
                }
              }
            }
            this.props.item.value = e.target.value;
            // event.target.value contains the new value
          }}
        />

      </div>
    )
  }
}

export default observer(String);